var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "filter-concise-summary",
      on: {
        click: _vm.onClick,
        mouseover: function($event) {
          _vm.showEditIcon = true
        },
        mouseout: function($event) {
          _vm.showEditIcon = false
        }
      }
    },
    [
      _vm._l(_vm.normalizedFilters, function(orFilter, index) {
        return _c(
          "div",
          { key: index, staticClass: "filter-or-bg clickable" },
          [
            index !== 0
              ? _c(
                  "strong",
                  {
                    staticClass: "filter-comparison",
                    class: {
                      "filter-comparison--and p-10 m-r-5 bg-holder":
                        orFilter.andCriteriaStart,
                      "filter-comparison--or": !orFilter.andCriteriaStart
                    },
                    attrs: { title: _vm.$t("EDIT_FILTERS") }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          orFilter.andCriteriaStart
                            ? _vm.$t("ROUTER_FILTER_AND").toLowerCase()
                            : _vm.$t("ROUTER_FILTER_OR").toLowerCase()
                        ) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", { attrs: { title: _vm.$t("EDIT_FILTERS") } }, [
              _vm._v(_vm._s(orFilter.tagDisplay))
            ]),
            _vm._v(" "),
            _c(
              "i",
              {
                staticClass: "m-l-5 m-r-5 f-s-11",
                attrs: { title: _vm.$t("EDIT_FILTERS") }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm._f("camelCaseFormat")(orFilter.comparisonTypeTemp.value)
                  )
                )
              ]
            ),
            _vm._v(" "),
            !_vm.isArray(orFilter.value)
              ? _c(
                  "strong",
                  {
                    staticClass: "contrast",
                    attrs: { title: _vm.$t("EDIT_FILTERS") }
                  },
                  [_vm._v("\n      " + _vm._s(orFilter.value) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isArray(orFilter.value)
              ? _c(
                  "span",
                  _vm._l(orFilter.value, function(value, valueIndex) {
                    return _c(
                      "strong",
                      {
                        key: valueIndex,
                        staticClass: "contrast",
                        attrs: { title: _vm.$t("EDIT_FILTERS") }
                      },
                      [
                        _vm._v("\n        " + _vm._s(value) + "\n        "),
                        valueIndex !== orFilter.value.length - 1
                          ? _c(
                              "span",
                              {
                                staticClass: "text-muted divider",
                                attrs: { title: _vm.$t("EDIT_FILTERS") }
                              },
                              [_vm._v("|")]
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("i", {
              staticClass: "fa fa-times m-l-5 delete-criteria",
              attrs: { title: _vm.$t("DELETE_CRITERIA") },
              on: {
                hover: function($event) {
                  $event.stopPropagation()
                  _vm.showEditIcon = false
                },
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.onDeleteOrCriteria(
                    orFilter.orIndex,
                    orFilter.andIndex
                  )
                }
              }
            })
          ]
        )
      }),
      _vm._v(" "),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showEditIcon,
            expression: "showEditIcon"
          }
        ],
        staticClass: "fa fa-pencil m-l-5",
        attrs: { title: _vm.$t("EDIT_FILTERS") },
        on: { click: _vm.onClick }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }